import { Link } from 'react-router-dom';
import { hotNovels } from '@/mocks/home';

export default function HotNovelsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              热门小说推荐
            </h2>
            <p className="mt-3 text-foreground-600 text-base">
              千万读者的选择，好评如潮
            </p>
          </div>
          <Link
            to="/category/xuanhuan"
            className="hidden sm:flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
          {hotNovels.map((novel) => (
            <Link
              key={novel.id}
              to={`/article/article-${novel.id}`}
              className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-200/50 transition-colors duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={novel.cover}
                  alt={novel.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${novel.title} - po18官网热门小说`}
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-accent-100 text-accent-700">
                    {novel.category}
                  </span>
                  <span className="text-xs text-accent-600">
                    <i className="ri-star-fill text-accent-500 mr-0.5"></i>
                    {novel.rating}
                  </span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors duration-200">
                  {novel.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3">{novel.author} · {novel.readers}人在读</p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {novel.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-10 sm:hidden">
          <Link
            to="/category/xuanhuan"
            className="whitespace-nowrap cursor-pointer flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200"
          >
            查看全部小说
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}